import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';
import { DASHBOARD_RULES, access, param } from '../../access';

const DashboardPage = withLazyLoading(() => import('../../pages/dashboardPage'));
const DashboardConfig = withLazyLoading(() => import('../../pages/dashboardConfig'));
const PageConfig = withLazyLoading(() => import('../../pages/pageConfig'));
const PageConfigV2 = withLazyLoading(() => import('../../pages/pageConfigV2'));
const DashboardPageList = withLazyLoading(() => import('../../pages/DashboardPageList'));
const UnifiedDashboardPage2 = withLazyLoading(() => import('../../pages/UnifiedDashboardPage2'));
const UnifiedDashboardPageList = withLazyLoading(() => import('../../pages/UnifiedDashboardPageList'));
const UnifiedPageConfig = withLazyLoading(() => import('../../pages/UnifiedPageConfig'));
const DnDUnifiedPageConfig = withLazyLoading(() => import('../../pages/DnDUnifiedPageConfig'));

const dashboardRoutes = [
    {
        path: '/dashboardConfig/:plantId',
        element: <DashboardConfig />,
        handle: { ...createCrumbHandle('Dashboard Configuration'), ...access(DASHBOARD_RULES.edit, param('plantId')) },
    },
    {
        path: '/dashboardPage/:plantId',
        handle: createCrumbHandle('Dashboard'),
        children: [
            {
                index: true,
                element: withPostHogTracker(<DashboardPage />),
                handle: access(DASHBOARD_RULES.view, param('plantId')),
            },
            {
                path: 'pageConfigv2/:plantId/:pageId',
                element: <PageConfigV2 />,
                handle: { ...createCrumbHandle('Dashboard Configuration'), ...access(DASHBOARD_RULES.edit, param('plantId')) },
            },
            {
                path: 'DashboardPageList/:plantId',
                element: withPostHogTracker(<DashboardPageList />),
                handle: { ...createCrumbHandle('Dashboard Pages'), ...access(DASHBOARD_RULES.edit, param('plantId')) },
            }
        ]
    },
    {
        path: '/UnifiedDashboardPage/:pageId',
        handle: createCrumbHandle('Dashboard'),
        children: [
            {
                index: true,
                element: withPostHogTracker(<UnifiedDashboardPage2 />),
                handle: access(DASHBOARD_RULES.view),
            },
            {
                path: 'UnifiedDashboardPageList',
                element: withPostHogTracker(<UnifiedDashboardPageList />),
                handle: { ...createCrumbHandle('Dashboard Pages'), ...access(DASHBOARD_RULES.edit) },
            },
            {
                path: 'UnifiedPageConfig/:pageId',
                element: <UnifiedPageConfig />,
                handle: { ...createCrumbHandle('Dashboard Configuration'), ...access(DASHBOARD_RULES.edit) },
            }
        ]
    },
    {
        path: '/pageConfig/:plantId/:pageId',
        element: <PageConfig />,
        handle: { ...createCrumbHandle('Dashboard Configuration'), ...access(DASHBOARD_RULES.edit, param('plantId')) },
    },
    {
        path: '/DnDUnifiedPageConfig/:pageId',
        element: <DnDUnifiedPageConfig />,
        handle: { ...createCrumbHandle('Dashboard Configuration'), ...access(DASHBOARD_RULES.edit) },
    },
];

export default dashboardRoutes;
